import React from "react";
import "./FloatingNewsCard.css";
import { toPersianDigits } from "../../utils/toPersianDigits";
import RetryLogoImage from "../media/RetryLogoImage";

const MAX_VISIBLE_SOURCES = 9;

const FloatingNewsCard = ({
  pendingNews = [],
  sourceNames = [],
  freshCount = pendingNews.length,
  favicons = {},
  onShow,
}) => {
  const safeFreshCount = Math.max(0, Number(freshCount) || 0);

  const sources = Array.from(
    new Set([
      ...sourceNames.filter(Boolean),
      ...pendingNews
        .map((item) => item?.source)
        .filter(Boolean),
    ])
  );

  if (sources.length === 0 || safeFreshCount === 0) return null;

  const visibleSources = sources.slice(0, MAX_VISIBLE_SOURCES);
  const moreCount = Math.max(0, sources.length - visibleSources.length);
  const isFreshCountCapped = safeFreshCount > 99;
  const newsCountText = isFreshCountCapped
    ? `+${toPersianDigits(99)}`
    : toPersianDigits(safeFreshCount);
  const label = `${newsCountText} خبر تازه`;

  return (
    <div className="floating-card-wrapper">
      <button
        type="button"
        className="floating-card"
        onClick={onShow}
        aria-label={label}
      >
        <span className="floating-card__inner">
          <span className="floating-card__icons">
            {visibleSources.map((source, index) => (
              <span
                key={source}
                className="floating-card__icon-wrap"
                style={{ zIndex: index + 1 }}
                title={toPersianDigits(source)}
              >
                {favicons[source] ? (
                  <RetryLogoImage
                    src={favicons[source]}
                    alt=""
                    className="floating-card__icon"
                    fallbackText={source.charAt(0)}
                    loading="lazy"
                    decoding="async"
                  />
                ) : (
                  <span className="floating-card__default-icon">
                    {source.charAt(0)}
                  </span>
                )}
              </span>
            ))}

            {moreCount > 0 && (
              <span
                className="floating-card__icon-wrap floating-card__more-icon"
                style={{ zIndex: visibleSources.length + 1 }}
                title={`${toPersianDigits(moreCount)} منبع دیگر`}
              >
                {toPersianDigits(moreCount)}+
              </span>
            )}
          </span>

          <span className="floating-card__text">
            {isFreshCountCapped ? (
              <>
                <span dir="ltr">{newsCountText}</span>{" "}
                خبر تازه
              </>
            ) : (
              label
            )}
          </span>
        </span>
      </button>
    </div>
  );
};

export default FloatingNewsCard;